"use strict";

/*  ------------------------------------------------------------------------ */

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectEntries(obj) {
    var entries = [];
    var keys = Object.keys(obj);

    for (var k = 0; k < keys.length; ++k) entries.push([keys[k], obj[keys[k]]]);

    return entries;
}

var merge = function merge(to, from) {

    for (var prop in from) {
        Object.defineProperty(to, prop, Object.getOwnPropertyDescriptor(from, prop));
    }

    return to;
};

/*  ------------------------------------------------------------------------ */

var pipez = module.exports = function (functions_, prev) {

    var functions = {}; // bound to self

    var functionNames = Reflect.ownKeys(functions_); // guaranteed to be in property creation order (as defined by the standard)
    var self = Object.assign(

    /*  Function of functions (call chain)  */

    function () {
        for (var _len = arguments.length, initial = Array(_len), _key = 0; _key < _len; _key++) {
            initial[_key] = arguments[_key];
        }

        return functionNames.reduce(function (memo, k) {
            return functions[k].call(self, memo, { initialArguments: initial });
        }, initial);
    }, // @hide

    /*  Additional methods     */

    {
        configure: function configure() {
            var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


            var modifiedFunctions = {};

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var k = _step.value;


                    var override = overrides[k],
                        before = overrides['+' + k] || function (x) {
                        return x;
                    },
                        after = overrides[k + '+'] || function (x) {
                        return x;
                    };

                    var boundArgs = typeof override === 'boolean' ? { yes: override } : override || {};

                    modifiedFunctions[k] = function (x, args) {

                        var fn = typeof override === 'function' ? override : functions[k]; // dont cache so people can dynamically change .impl ()

                        var newArgs = Object.assign({}, boundArgs, args),
                            maybeFn = newArgs.yes === false ? function (x) {
                            return x;
                        } : fn;

                        return after.call(this, maybeFn.call(this, before.call(this, x, newArgs), newArgs), newArgs);
                    };
                };

                for (var _iterator = functionNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return pipez(modifiedFunctions, self).methods(this.methods_);
        },
        from: function from(name) {

            var subset = null;

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = functionNames[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _k = _step2.value;

                    if (_k === name) {
                        subset = { takeFirstArgument: function takeFirstArgument(args) {
                                return args[0];
                            } };
                    }
                    if (subset) {
                        subset[_k] = functions[_k];
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return pipez(subset, self);
        },
        before: function before(name) {

            var subset = {};

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = functionNames[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _k2 = _step3.value;

                    if (_k2 === name) {
                        break;
                    }
                    subset[_k2] = functions[_k2];
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return pipez(subset, self);
        },


        methods_: {},

        methods: function methods(_methods) {
            return merge(this, merge(this.methods_, _methods));
        },


        get impl() {
            return functions;
        },
        get prev() {
            return prev;
        }
    });

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
        for (var _iterator4 = _objectEntries(functions_)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _step4$value = _slicedToArray(_step4.value, 2),
                _k3 = _step4$value[0],
                f = _step4$value[1];

            functions[_k3] = f.bind(self);
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
            }
        } finally {
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }

    return self;
};

/*  ------------------------------------------------------------------------ */

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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